const syncRangeFields = (): void => {
  document.querySelectorAll<HTMLElement>('.js-range-fields').forEach((container) => {
    const maxField = container.querySelector<HTMLInputElement>('.js-max-field')
    const minField = container.querySelector<HTMLInputElement>('.js-min-field')
    if (!maxField || !minField) return
    const syncEmptyCounterpart = (source: HTMLInputElement, target: HTMLInputElement) => {
      if (target.value === '' && source.value !== '') {
        target.value = source.value
        target.dispatchEvent(new Event('change'))
        target.dispatchEvent(new Event('input'))
      }
    }
    minField.addEventListener('change', () => syncEmptyCounterpart(minField, maxField))
    maxField.addEventListener('change', () => syncEmptyCounterpart(maxField, minField))
  })
}

document.addEventListener('turbo:load', syncRangeFields)
